if (typeof gtag !== 'undefined') {
  document.addEventListener(
    'signupform-success',
    function (event) {
      gtag('event', 'signupform-success', {
        event_category: 'engagement',
        event_label: 'Påmeldt arrangement',
      });
    },
    false,
  );
}
